var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:_vm.$abem({ block: 'a-completedMessage' })},[_vm._v(" "+_vm._s(_vm.$t("Your submission was successful."))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }